import type { Config } from '../../../server/config';

type ReaderUrlOptions = {
    hosts: Config['hosts'];
    username: string;
    documentName: string;
    initialPageNumber: number;
    referrerUrl: string;
    delayTracking: boolean;
};

const removeQueryString = (url: string) => url.replace(/\?.*$/, '');

export const getReaderSrc = ({
    delayTracking,
    documentName,
    hosts,
    initialPageNumber,
    referrerUrl,
    username,
}: ReaderUrlOptions): string => {
    const params = {
        d: documentName,
        p: initialPageNumber,
        r: encodeURIComponent(removeQueryString(referrerUrl)),
        u: username,
        delayTracking: delayTracking ? 'true' : '',
    };

    const query = Object.entries(params)
        .filter(([_k, value]) => value !== '')
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    return (
        `https://${hosts.embed}/issuu-reader3-embed-files/latest/document-page-reader.html` +
        (query ? `?${query}` : '')
    );
};
